(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ContactController', ContactController);


        ContactController.$inject = [ '$timeout', 'Auth', 'LoginService', 'errorConstants', '$state', '$rootScope', '$scope', 'AlertService', 'Principal'];

    function ContactController ($timeout, Auth, LoginService, errorConstants, $state, $rootScope, $scope, AlertService, Principal) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.contact = contact;
        vm.contactParam = {};
        vm.success = null;

        vm.contactParam.email = Principal.getUserEmail();

        $timeout(function (){angular.element('#login').focus();});

        function contact () {
            console.log('contactParam', vm.contactParam);
            /*if($scope.form.$invalid){
                vm.errorValidation = 'ERROR';
            }*/
            Auth.contactUs(vm.contactParam).then(function () {
                vm.contactParam = {};
                $scope.form.$setPristine();
                vm.error = null;
                vm.success = 'OK';
                $state.go('thank-you');

            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
